import React from 'react';
import { useIsFetching } from 'react-query';
import { css as reactCss } from '@emotion/react';

import { Spinner } from './botox-spinner';

export const UpdateLoader: React.FC = () => {
  const enable_widget_border = true;

  const isFetching = useIsFetching(['global-state']);
  if (!isFetching) {
    return null;
  }

  return (
    <div css={styles.wrapper(!!enable_widget_border)} data-test="loader">
      <Spinner />
    </div>
  );
};

const styles = {
  wrapper: (enableWidgetBorder: boolean) =>
    reactCss({
      opacity: '0.9',
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'white',
      zIndex: 100,
      borderRadius: enableWidgetBorder ? '6px' : '0',
      // Account for borders on the widget
      top: enableWidgetBorder ? '1px' : '0',
      bottom: enableWidgetBorder ? '1px' : '0',
      left: enableWidgetBorder ? '1px' : '0',
      right: enableWidgetBorder ? '1px' : '0',
    }),
};
